export default "__VITE_ASSET__CCq83eJ8__"